import { render, staticRenderFns } from "./tooltips.vue?vue&type=template&id=52dc2e3a"
import script from "./tooltips.vue?vue&type=script&lang=js"
export * from "./tooltips.vue?vue&type=script&lang=js"
import style0 from "./tooltips.vue?vue&type=style&index=0&id=52dc2e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports